
import { ProductCompositionRow } from "@/models/base";
import AppRow from "./ProductEditCompositionRow.vue";
import { ProductRow } from "@/utils/product-row";
import Vue from "vue";

export default Vue.extend({
	props: {
		items: {
			type: Array as () => ProductCompositionRow[],
			required: true
		},
		selectedRow: Object as () => ProductCompositionRow,
	},
	computed: {
		sortableAttributes():any {
			return{
				tag: "tbody",
				disableX: true,
				keepInY: true,
				targetClass: "handle",
				items: this.items
			};
		}
	},
	methods: {
		onEditRow(row: ProductRow) {
			this.$emit("edit", row);
		},
		onRowSelect(row: ProductRow) {
			this.$emit("select", row);
		},
		onRemove(row: ProductRow) {
			this.$emit("remove", row);
		},
		onInsertRow() {
			this.$emit("add");
		},
		onBold(row:ProductRow) {
			row.getRowConfig().Bold = !row.getRowConfig().Bold;
		},
		onHide(row:ProductRow) {
			row.getRowConfig().Hidden = !row.getRowConfig().Hidden;
		},
		onSubTotal(row:ProductRow) {
			row.getRowConfig().SubTotal = !row.getRowConfig().SubTotal;
		},
		trigger(value: string) {
			this.$emit(value);
		},
		onKeyDown(e:KeyboardEvent){

			if ((e.target as HTMLTextAreaElement).className.indexOf("w-input") >= 0 ||
				(e.target as HTMLTextAreaElement).className.indexOf("w-textarea") >= 0 ||
				(e.target as HTMLTextAreaElement).className.indexOf("ql-editor") >= 0 ||
				(e.target as HTMLTextAreaElement).className.indexOf("w-select-button") >= 0){
				return;
			}

			if (e.keyCode == 45 ) {
				this.onInsertRow();
			}
			if (e.keyCode == 32 ) {
				//toggle row visibility
				this.selectedRow.getRowConfig().Hidden = !this.selectedRow.getRowConfig().Hidden;
			}

			if (e.ctrlKey && e.key === "+") {
				this.$emit("add");
			}
		}
	},
	mounted(){
		window.addEventListener("keyup", this.onKeyDown);
	},
	destroyed(){
		window.removeEventListener("keyup", this.onKeyDown);
	},
	components: {
		AppRow,
	},
	i18nEx: {
		componentPrefix: "components.products-table"
	}
});
